import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Grid,
  FormControl,
  Divider,
  Typography,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Autocomplete,
} from "@mui/material";
import ServiceType from "./ServiceType";

const provinceOptions = [
  { label: "กาฬสินธุ์", value: "กาฬสินธุ์" },
  { label: "ขอนแก่น", value: "ขอนแก่น" },
];

const districtOptions = [
  { label: "ยางตลาด", value: "ยางตลาด" },
  { label: "เมือง", value: "เมือง" },
];

const sub_districtOptions = [
  { label: "หัวนาคำ", value: "หัวนาคำ" },
  { label: "ยางตลาด", value: "ยางตลาด" },
];

const serviceOptions = [
  { name: "clinic", label: "คลินิก" },
  { name: "pharmacy", label: "ร้านยา" },
  { name: "privateHospital", label: "โรงพยาบาลเอกชน" },
  { name: "others", label: "อื่นๆ" },
];

// interface FormData {
//   orgenization_data: string; //ข้อมูลหน่วยบริการ
//   health_office_type: boolean; 
//   hname_th: string;  //ชื่อหน่วยบริการ
//   hcode: string;  //รหัสหน่วยบริการ
//   address: string;
//   moo: string;
//   soi: string;
//   street: string;
//   province: string;
//   district: string;
//   sub_district: string;
//   zip_code: string;
//   email: string;
//   mobile_number: string;

// }
// interface FormDataServiceType {
//   service_type: string;
//   service_type_note: string;
//   otherDetails: string;
// }


interface FormDataServiceType {
  serviceType: string;
  clinicDetails: string;
  otherDetails: string;
}

interface FormData  {
  health_office_type: string;
  hname_th: string;
  hcode: string;
  address: string;
  moo: string;
  soi: string;
  street: string;
  province: string;
  district: string;
  sub_district: string;
  zip_code: string;
  email: string;
  mobile_number: string;
}

const ServiceInfo: React.FC = () => {
  const [formDataServiceType, setFormDataServiceType] = useState<FormDataServiceType>({
    serviceType: "",
    clinicDetails: "",
    otherDetails: "",
  });
  const [formData, setFormData] = useState<FormData>({
    health_office_type: "",
    hname_th: "",
    hcode: "",
    address: "",
    moo: "",
    soi: "",
    street: "",
    province: "",
    district: "",
    sub_district: "",
    zip_code: "",
    email: "",
    mobile_number: "",
  });

  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    const storedDataServiceInfo = localStorage.getItem("serviceInfo");
    if (storedDataServiceInfo) {
      try {
        setFormData(JSON.parse(storedDataServiceInfo));
      } catch (error) {
        console.error("Error parsing JSON from localStorage:", error);
      }
    }
  
    const storedDataServiceType = localStorage.getItem("serviceType");
    if (storedDataServiceType) {
      try {
        setFormDataServiceType(JSON.parse(storedDataServiceType));
      } catch (error) {
        console.error("Error parsing JSON from localStorage:", error);
      }
    }
  }, []);
  

  const handleFormChangeInfo = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: value.trim() === "" }));
  };

  const handleCheckboxServiceInfo = (value: string) => {
    setFormData((prev) => ({
      ...prev,
      health_office_type: prev.health_office_type === value ? "" : value,
    }));
    setErrors((prev) => ({ ...prev, health_office_type: false }));
  };

  const handleCheckboxServiceType = (value: string) => {
    setFormDataServiceType((prev) => ({
      ...prev,
      serviceType: prev.serviceType === value ? "" : value,
      clinicDetails: "", 
      otherDetails: "",
    }));
  
    setErrors((prev) => ({
      ...prev,
      clinicDetails: false,
      otherDetails: false,
    }));
  };

  const handleTextServiceType = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormDataServiceType((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: value.trim() === "" }));
  };

  const validateFormServiceType = () => {
    let newErrors: { [key: string]: boolean } = {};
    if (formDataServiceType.serviceType === "multiClinic" && !formDataServiceType.clinicDetails) {
      newErrors.clinicDetails = true;
    }
    if (formDataServiceType.serviceType === "other" && !formDataServiceType.otherDetails) {
      newErrors.otherDetails = true;
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const validateFormServiceInfo = () => {
    let newErrors: { [key: string]: boolean } = {};
    if (!formData.health_office_type) {
      newErrors.health_office_type = true;
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleSubmit = () => {
  if (!validateFormServiceType() || !validateFormServiceInfo()) {
    Swal.fire({
      title: "กรุณากรอกข้อมูลให้ครบถ้วน",
      icon: "info",
    });
    return;
  }

  // แสดงข้อมูลที่ได้จากฟอร์ม
   console.log("ข้อมูล ServiceType:", formDataServiceType);
  console.log("ข้อมูล ServiceInfo:", formData);
};

  return (
    <form>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
        {/* ข้อมูลหน่วยบริการ */}
        <Grid item xs={12} md={2} sx={{ alignSelf: "center" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            ข้อมูลหน่วยบริการ
          </Typography>
        </Grid>
        <Grid item xs={12} md={10}>
          <Grid container spacing={2} alignItems="center">
          {serviceOptions.map((option) => (
              <Grid item key={option.name}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.health_office_type === option.name}
                      onChange={() => handleCheckboxServiceInfo(option.name)}
                    />
                  }
                  label={option.label}
                />
              </Grid>
            ))}
          </Grid>
          {errors.serviceType && (
            <Typography variant="body2" color="error">
              กรุณาเลือกประเภทหน่วยบริการอย่างใดอย่างหนึ่ง
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} md={2}></Grid>
        <Grid item xs={12} md={10}>
          <Grid container spacing={2}>
            {/* ชื่อหน่วยบริการ */}
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  label={
                    <span>
                      ชื่อหน่วยบริการ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกชื่อหน่วยบริการ"
                  value={formData.hname_th}
                  name="hname_th"
                  onChange={handleFormChangeInfo}
                  error={errors.hname_th}
                  helperText={
                    errors.hname_th ? "กรุณากรอกชื่อหน่วยบริการ" : ""
                  }
                />
              </FormControl>
            </Grid>
            {/* รหัสหน่วยบริการ */}
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  label={
                    <span>
                      รหัสหน่วยบริการ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกรหัสหน่วยบริการ"
                  value={formData.hcode}
                  name="hcode"
                  onChange={handleFormChangeInfo}
                  error={errors.hcode}
                  helperText={
                    errors.hcode ? "กรุณากรอกรหัสหน่วยบริการ" : ""
                  }
                />
              </FormControl>
            </Grid>
            {/* สถานที่ตั้งหน่วยบริการ */}
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  label={
                    <span>
                      สถานที่ตั้งหน่วยบริการ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกสถานที่ตั้งหน่วยบริการ"
                  value={formData.address}
                  name="address"
                  onChange={handleFormChangeInfo}
                />
              </FormControl>
            </Grid>
            {/* หมู่/อาคาร */}
            <Grid item xs={12} md={2}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  label={
                    <span>
                      หมู่ / อาคาร <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกหมู่/อาคาร"
                  value={formData.moo}
                  name="moo"
                  onChange={handleFormChangeInfo}
                />
              </FormControl>
            </Grid>
            {/* ตรอก/ซอย */}
            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ minWidth: "100%" }}
                  label={
                    <span>
                      ตรอก / ซอย <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  id="outlined-basic"
                  placeholder="กรุณากรอกตรอก / ซอย"
                  value={formData.soi}
                  name="soi"
                  onChange={handleFormChangeInfo}
                />
              </FormControl>
            </Grid>
            {/* ถนน */}
            <Grid item xs={12}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ minWidth: "100%" }}
                  label={
                    <span>
                      ถนน <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกถนน"
                  value={formData.street}
                  name="street"
                  onChange={handleFormChangeInfo}
                />
              </FormControl>
            </Grid>
            {/* จังหวัด, อำเภอ, ตำบล / แขวง, รหัสไปรษณีย์ */}
            <Grid item xs={12} md={3}>
              <FormControl sx={{ minWidth: "100%" }}>
                <Autocomplete
                  options={provinceOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    provinceOptions.find(
                      (option) => option.value === formData.province
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setFormData({
                      ...formData,
                      province: newValue?.value || "",
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          จังหวัด <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      placeholder="กรุณาเลือกจังหวัด"
                      error={errors.province}
                      helperText={errors.province ? "กรุณาเลือกจังหวัด" : ""}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl sx={{ minWidth: "100%" }}>
                <Autocomplete
                  options={districtOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    districtOptions.find(
                      (option) => option.value === formData.district
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setFormData({
                      ...formData,
                      district: newValue?.value || "",
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          อำเภอ <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      placeholder="กรุณาเลือกอำเภอ"
                      error={errors.district}
                      helperText={errors.district ? "กรุณาเลือกอำเภอ" : ""}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl sx={{ minWidth: "100%" }}>
                <Autocomplete
                  options={sub_districtOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    sub_districtOptions.find(
                      (option) => option.value === formData.sub_district
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setFormData({
                      ...formData,
                      sub_district: newValue?.value || "",
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          ตำบล / แขวง <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      placeholder="กรุณาเลือกตำบล / แขวง"
                      error={errors.sub_district}
                      helperText={
                        errors.sub_district ? "กรุณาเลือกตำบล / แขวง" : ""
                      }
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  label={
                    <span>
                      รหัสไปรษณีย์ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกรหัสไปรษณีย์"
                  value={formData.zip_code}
                  name="zip_code"
                  onChange={handleFormChangeInfo}
                  fullWidth
                  maxRows={5}
                  inputProps={{
                    maxLength: 5,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  label={
                    <span>
                      ไปรษณีย์อิเล็กทรอนิกส์ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์"
                  value={formData.email}
                  name="email"
                  onChange={handleFormChangeInfo}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  label={
                    <span>
                      หมายเลขโทรศัพท์มือถือ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกหมายเลขโทรศัพท์มือถือ"
                  value={formData.mobile_number}
                  name="mobile_number"
                  onChange={handleFormChangeInfo}
                />
              </FormControl>
            </Grid>
            <ServiceType formDataServiceType={formDataServiceType} handleCheckboxServiceType={handleCheckboxServiceType} handleTextServiceType={handleTextServiceType} errors={errors} />
          </Grid>
        </Grid>
      </Grid>
    </form>
    
  );
};

export default ServiceInfo;
